export const FinancialRatiosType = {
	Audited: 0,
	Internal: 1,
};
